export default [
  'RADAR_WIND',
]